import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useAppStore } from '@/hooks/useAppStore'
import { WelcomeScreen }    from '@/pages/WelcomeScreen'
import { ModeScreen }       from '@/pages/ModeScreen'
import { QuizScreen }       from '@/pages/QuizScreen'
import { DnaScreen }        from '@/pages/DnaScreen'
import { JourneyScreen }    from '@/pages/JourneyScreen'
import { LeadGateScreen }   from '@/pages/LeadGateScreen'
import { JourneyCardScreen } from '@/pages/JourneyCardScreen'
import { FullItineraryScreen } from '@/pages/FullItineraryScreen'

const VARIANTS = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } },
  exit:    { opacity: 0, transition: { duration: 0.25 } },
}

export default function App() {
  const screen = useAppStore((s) => s.screen)
  return (
    <div style={{ minHeight: '100vh', background: 'var(--forest)' }}>
      <AnimatePresence mode="wait">
        <motion.div key={screen} variants={VARIANTS} initial="initial" animate="animate" exit="exit">
          {screen === 'welcome' && <WelcomeScreen />}
          {screen === 'mode'    && <ModeScreen />}
          {screen === 'quiz'    && <QuizScreen />}
          {screen === 'dna'     && <DnaScreen />}
          {screen === 'journey' && <JourneyScreen />}
          {screen === 'gate'    && <LeadGateScreen />}
          {screen === 'card'    && <JourneyCardScreen />}
          {screen === 'itinerary' && <FullItineraryScreen />}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
